module.exports = __webpack_public_path__ + "static/advice4-1fad56bf31538cdd0133a24b1405be26.png";